import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { GrLocation, GrMailOption, GrPhone } from "react-icons/gr";
import { addContactAction } from "../../redux/actions";
import ContactCard from "../Cards/ContactCard";
import ContactFormCard from "../Cards/ContactFormCard";
import TitleHeader from "../Header/TitleHeader";
import { useDispatch, useSelector } from "react-redux";
// import Alert from "react-bootstrap/Alert";
import { Toast, ToastContainer } from "react-bootstrap";

function SectionF() {
  const [alert, setAlert] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    setTimeout(() => {
      setAlert(false);
    }, 3000);
  }, [alert]);

  const onSubmit = async (values) => {
    const requestBody = {
      email: values?.Email || "",
      name: values?.Username || "",
      subject: values?.Subject || "",
      current_message: values?.Message || "",
    };
    const body = {
      values: requestBody,
      onSuccess: async (res) => {
        console.log("SUCCESS::", res);
        // window.alert("Details Added Successfully");
        setAlert(!alert);
      },
      onFailure: (res) => {
        console.log("FAILURE::", res);
      },
    };
    dispatch(addContactAction(body));
  };
  return (
    <Col id="tab_5" className="sectionF">
      <TitleHeader title="Contact Me" />
      <div className="desc_Con textContainer">
        <text className="regularText">
          I always here to assist you with any questions or concerns. For your
          satisfaction,I am committed to providing the best possible experience.
        </text>
      </div>

      <Row className="rowCard">
        <Col sm={12} md={4} lg={4}>
          <Col className="leftCard">
            <ContactCard
              title={"Location"}
              desc={
                <a
                  href="https://www.google.com/maps/place/Wateen+Telecom+Limited/@31.4798131,74.3583022,17z"
                  className="text"
                  target="_blank"
                >
                  Lahore, Pakistan
                </a>
              }
              icon={<GrLocation size={20} />}
            />
            <ContactCard
              title={"Email"}
              desc={
                <a href="mailto:mianumerfareed72@gmail.com" className="text">
                  mianumerfareed72@gmail.com
                </a>
              }
              icon={<GrMailOption size={20} />}
            />
            <ContactCard
              title={"Call"}
              desc={
                <a href="tel:+923044228402" className="text">
                  (+92) 3044228402
                </a>
              }
              icon={<GrPhone size={20} />}
            />
          </Col>
        </Col>
        <Col sm={12} md={8} lg={8}>
          <Col className="rightCard">
            <ContactFormCard
              onPress={(values) => {
                onSubmit(values);
              }}
            />
          </Col>
        </Col>
      </Row>

      {/* <Alert
        style={{
          width: "30%",
          display: "flex",
          justifyContent: "center",
          height: "5rem",
          alignItems: "center",
        }}
        show={alert}
        // onClose={() => setAlert(false)}
        variant="success"
      >
        Details Submitted Successfully!!
      </Alert> */}
      <ToastContainer style={{}} position="top-end" className="position-fixed">
        <Toast
          show={alert}
          onClose={() => setAlert(false)}
          className="d-inline-block m-1"
          bg="success"
        >
          <Toast.Header closeButton={true}>
            <strong className="me-auto">Success</strong>
          </Toast.Header>
          <Toast.Body className={"text-white"}>
            Message Sent Successfully
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Col>
  );
}

export default SectionF;
